import Loading from './../../misc/Loading';
import React from 'react';
import campaignModel from './../../../../../model/campaign';
import dealerModel from './../../../../../model/dealer';
import campaignOverrideModel from './../../../../../model/campaignOverride';
import {NavLink as Link} from 'react-router-dom';
import withRouter from '/src/components/misc/withRouter';
import PublishStatusTableRow from '../../table/PublishStatusTableRow';
import PublishStatusDot from '../../../../misc/PublishStatusDot';
import config from './../../../../../../config/config';

class CampaignOverridesOverview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      working: true,
      error: null,
      overrides: [],
      campaigns: [],
      mfDealers: {},
      mfDealerLookupId: 'dealer_027'
    };

    this.handleTaskDealerChange = this.handleTaskDealerChange.bind(this);
  }

  componentDidMount() {
    document.title = 'Admin - MF Forsidekampanjer';
    const makeChoices = config.campaigns.mfRotation.makes;
    // Toggle the top frontpage campaign between makes every x days
    const currentDate = new Date();
    const baseline = new Date();
    baseline.setFullYear(config.campaigns.mfRotation.startYear);
    baseline.setMonth(config.campaigns.mfRotation.startMonth);
    baseline.setDate(config.campaigns.mfRotation.startDay);

    const diffInMs = currentDate - baseline;
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    const diffInTwoWeeks = Math.floor(diffInDays / config.campaigns.mfRotation.toggleDays);

    const currentMFFirstMake = makeChoices[diffInTwoWeeks % makeChoices.length];
    const currentMFFirstMakeIndex = makeChoices.indexOf(currentMFFirstMake);

    // "rotate" the array to start at current first make
    const makesOrder = [...makeChoices.slice(currentMFFirstMakeIndex), ...makeChoices.slice(0, currentMFFirstMakeIndex)];
    // Find days needed to change diffInTwoWeeks (which causes change in array lookup)
    const nextChangeInDays = config.campaigns.mfRotation.toggleDays - (diffInDays % config.campaigns.mfRotation.toggleDays);

    const nextChangeDate = new Date();
    nextChangeDate.setDate(nextChangeDate.getDate() + nextChangeInDays);

    this.setState({
      makesOrder: makesOrder,
      nextChangeInDays: nextChangeInDays,
      nextChangeDate: nextChangeDate
    });


    return Promise.all([
      campaignModel.allActive(1),
      campaignOverrideModel.allActive(1),
      campaignOverrideModel.allUpcoming(1),
      dealerModel.query('fields.name', {
        'fields.skipBuild[ne]': true, // Note: [ne] instead of check of false, because we want to include those with noe value
        'fields.slug[match]': 'motorforum',
        'sys.archivedAt[exists]': false,
        'sys.publishedVersion[exists]': true,
        'order': 'fields.name'
      })
    ]).then(([[campaigns, campaignsTotal], [overrides, overridesTotal], [overridesUpcoming, overridesUpcomingTotal], mfDealers]) => {
      this.setState({
        campaigns: campaigns,
        campaignsTotal: campaignsTotal,
        overrides: overrides,
        overridesTotal: overridesTotal,
        overridesUpcoming: overridesUpcoming,
        overridesUpcomingTotal: overridesUpcomingTotal,
        mfDealers: mfDealers.items,
        working: false
      });
    });
  }

  handleTaskDealerChange(e) {
    this.setState({
      mfDealerLookupId: e.target.value
    });
  }

  printCampaignType(campaignType) {
    const types = {
      newcar: 'Nybil',
      parts: 'Tilbehør',
      service: 'Service',
      reservation: 'Reservasjon'
    };

    return types[campaignType];
  }

  printMakes(makes) {
    let makesString = '';
    if (makes) {
      makesString += makes.map((make) => {
        return make.name;
      });
    }
    return makesString;
  }

  render() {
    if (this.state.working) {
      return (
        <Loading title="Kampanje" text="Laster oversikt" />
      );
    }

    const primaryMFCampaignCustom = this.state.overrides.find((c) => c.primary);
    const currentMFPromotedCampaignId = primaryMFCampaignCustom ? primaryMFCampaignCustom.id : null;

    // Campaign rotation and override logic.
    // This should mirror the logic for frontend, as done under the processCampaigns() functionin process.js in the sites repo.

    const extractedMakeCampaigns = {};
    // Go through campaigns and find first campaign of each make
    const makesToCheckFor = config.campaigns.mfRotation.makes.slice();
    for (let cIndex = 0; cIndex < this.state.campaigns.length; ++cIndex) {
      const c = this.state.campaigns[cIndex];
      if (
        // Should not be a hidden campaign
        !c.hiddenCampaign &&
        // Should be tied to a make
        c.makes[0] &&
        // Check if published to wanted dealer
        c.dealerIds.includes(this.state.mfDealerLookupId) &&
        // Make sure it is not the promoted campaign
        (c.id !== currentMFPromotedCampaignId)
      ) {
        const make = c.makes[0].slug;
        const makeIndex = makesToCheckFor.indexOf(make);
        if (makeIndex !== -1) {
          extractedMakeCampaigns[make] = c;
          // Remove the make from wanted array
          makesToCheckFor.splice(makeIndex, 1);

          if (!makesToCheckFor.length) {
            // Found all the makes
            break;
          }
        }
      }
    }

    // Create array with wanted order of campaigns (based on the make rotation)
    const currentMFCampaigns = [];
    for (let i = 0; i < this.state.makesOrder.length; i++) {
      if (extractedMakeCampaigns.hasOwnProperty(this.state.makesOrder[i])) {
        currentMFCampaigns.push(extractedMakeCampaigns[this.state.makesOrder[i]]);
      }
    }


    // Go through and find any override campaigns for each index
    // This creates a map with override index as key, and campaign ID as value.
    const overrideCampaignMap = this.state.overrides.reduce((map, oc) => {
      if (
        !oc.primary &&
        oc.overrideIndex !== undefined &&
        oc.campaign.dealerIds.includes(this.state.mfDealerLookupId)
      ) {
        if (!map[oc.overrideIndex]) {
          map[oc.overrideIndex] = oc.campaign.id;
        }
      }

      return map;
    }, {});

    // Insert the override campaigns into the correct index
    // Note: We do a lot of checks for valid campaign here instead of in the previous loop (overrideCampaignMap),
    // because we want just the first valid override to be used, even if it does not contain a valid campaign.
    // (e.g. we don't want to fallback to the next override if any )
    // if not, the resolv logic would be too complicated to easily work with and understand when editing/using?
    const extractedOverrideCampaignIndexes = {
      // Here we want to hold the extracted campaign indexes with campaign id as key
      // (The index of the campaign in the campaingsProcessed array)
      // e.g:
      // {'7GfK46VZoGnfWtatHBN2NU': 6}
    };
    const campaignIdsToCheckFor = Object.values(overrideCampaignMap);
    for (let cIndex = 0; cIndex < this.state.campaigns.length; ++cIndex) {
      const c = this.state.campaigns[cIndex];
      const id = c.id;
      const campaignIndex = campaignIdsToCheckFor.indexOf(id);
      if (
        // Its a campaign we want..
        campaignIndex !== -1 &&
        // Should not be a hidden campaign
        !c.hiddenCampaign &&
        // Should be tied to a make
        c.makes[0] &&
        // Make sure it is not the promoted campaign
        (id !== currentMFPromotedCampaignId)
      ) {
        // save the index in our lookup
        extractedOverrideCampaignIndexes[id] = cIndex;
        // Remove the make from wanted array
        campaignIdsToCheckFor.splice(campaignIndex, 1);

        if (!campaignIdsToCheckFor.length) {
          // Found all the campaigns
          break;
        }
      }
    }

    // Finally.. override campaign positions with the fully resolved campaign object..
    Object.keys(overrideCampaignMap).reverse().forEach((campaignOverrideIndex) => {
      const campaignOverrideId = overrideCampaignMap[campaignOverrideIndex];

      if (extractedOverrideCampaignIndexes.hasOwnProperty(campaignOverrideId)) {
        const overrideCampaignIndex = extractedOverrideCampaignIndexes[campaignOverrideId];
        const overrideCampaign = this.state.campaigns[overrideCampaignIndex];

        // Check if this campaign is already one of the campaigns in normal rotation
        const indexOfOverrideInDefaultList = currentMFCampaigns.findIndex((c) => c.id === overrideCampaign.id);

        overrideCampaign._original = currentMFCampaigns[campaignOverrideIndex];
        currentMFCampaigns[campaignOverrideIndex] = overrideCampaign;

        // If it was in the normal rotation as well, and we override it in a different position, remove the normal one.
        // Note: This means we end up with 1 less campaign in the overview than we want, but for now this behavuour is "unhandled",
        // on the dealer site we would just display the next campaign based on normal ranking
        if (indexOfOverrideInDefaultList !== -1 && indexOfOverrideInDefaultList !== campaignOverrideIndex) {
          currentMFCampaigns.splice(indexOfOverrideInDefaultList, 1);
        }
      }
    });

    return (
      <section>
        <div className="mf-model">
          <ol className="breadcrumb mf-margin-top-20">
            <li><Link to="/">Forsiden</Link></li>
            <li>Motorforum</li>
            <li className="active">Kampanjer</li>
          </ol>
          <div className="page-header">
            <div className="pull-right">
              <Link
                to={'/motorforum/campaigns/override/new'}
                className="btn btn-success"
                disabled={this.props.working}
              >
                Ny overstyring
              </Link>
            </div>
            <h1>Forsidekampanjer</h1>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <h4>Nåværende kampanjerekkefølge</h4>
            <ol style={{
              textTransform: 'capitalize'
            }}>
              {this.state.makesOrder.map((make) => <li key={make}>{make}</li>)}
            </ol>
            <p><strong>{this.state.nextChangeInDays}</strong> dager til neste endring hvor <span style={{textTransform: 'capitalize'}}>{this.state.makesOrder[1]}</span> har første kampanje ({this.state.nextChangeDate.toLocaleDateString('nb')})</p>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <h2>Aktuelle kampanjeoverstyringer</h2>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th title="Publiseringsstatus"></th>
                  <th>Navn</th>
                  <th>Plassering</th>
                  <th>Til - fra</th>
                  <th>Kampanjetittel</th>
                </tr>
              </thead>

              <tbody>
                {this.state.overrides.map((override) => {
                  if (!override.primary) {
                    return;
                  }
                  return (
                    <PublishStatusTableRow entry={override} key={`override1-${override.id}`}>
                      <td className="text-center">
                        <PublishStatusDot entry={override} />
                      </td>
                      <td>
                        <Link to={`/motorforum/campaigns/override/${override.id}`}>{override.name}</Link>
                      </td>
                      <td><strong>Primærkampanje</strong></td>
                      <td>{override.startDate.toLocaleDateString('nb')} - {override.expiryDate.toLocaleDateString('nb')}</td>
                      <td><Link to={`/campaigns/${override.campaign.id}`}>{override.campaign.name}</Link></td>
                    </PublishStatusTableRow>
                  );
                })}
              </tbody>

              <tbody>
                {this.state.overrides.map((override) => {
                  if (override.primary) {
                    return;
                  }
                  return (
                    <PublishStatusTableRow entry={override} key={`override1-${override.id}`}>
                      <td className="text-center">
                        <PublishStatusDot entry={override} />
                      </td>
                      <td>
                        <Link to={`/motorforum/campaigns/override/${override.id}`}>{override.name}</Link>
                      </td>
                      <td>{override.overrideIndex + 1}</td>
                      <td>{override.startDate.toLocaleDateString('nb')} - {override.expiryDate.toLocaleDateString('nb')}</td>
                      <td><Link to={`/campaigns/${override.campaign.id}`}>{override.campaign.name}</Link></td>
                    </PublishStatusTableRow>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <h2>Forsidekampanjer</h2>
            <form className="form-inline mf-margin-bottom-10">
              <label>Forhåndsvis kampanjer hos MF forhandler hos &nbsp;</label>
              <select className="form-control input-sm" value={this.state.mfDealerLookupId} onChange={this.handleTaskDealerChange}>
                <option disabled value="">Velg forhandler</option>
                {this.state.mfDealers.map((ds) => <option
                  key={ds.sys.id}
                  value={ds.sys.id}
                >{ds.fields.name['nb-NO']}</option>)}
              </select>
            </form>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th title="Publiseringsstatus"></th>
                  <th>Tittel</th>
                  <th>Intern Sammendrag</th>
                  <th>Til - fra</th>
                  <th>Pri</th>
                  <th>Type</th>
                  <th>Merke(r)</th>
                  <th>Modell</th>
                  <th title="Forhandlere">#</th>
                </tr>
              </thead>

              <tbody>
                {currentMFCampaigns.map((campaign, i) => {
                  return (
                    <PublishStatusTableRow entry={campaign} key={`campaign-${campaign.id}-${i}`}>
                      <td className="text-center" title="Publiseringsstatus">
                        <PublishStatusDot entry={campaign} />
                      </td>
                      <td>
                        <Link to={`/campaigns/${campaign.id}`}>{campaign.name}</Link>
                        {campaign._original && <div>
                          (Overstyrer <Link to={`/campaigns/${campaign._original.id}`}>{campaign._original.name}</Link>)
                        </div>}
                      </td>
                      <td>
                        {campaign.summary}
                      </td>
                      <td>
                        {campaign.startDate.toLocaleDateString('nb')} - {campaign.expiryDate.toLocaleDateString('nb')}
                      </td>
                      <td>
                        {campaign.priority}
                      </td>
                      <td>
                        {this.printCampaignType(campaign.type)}
                      </td>
                      <td>
                        {this.printMakes(campaign.makes)}
                      </td>
                      <td>
                        {campaign.model &&
                          <span>{campaign.model.name}</span>
                        }
                      </td>
                      <td className="text-center" title="Forhandlere">
                        {campaign.dealers &&
                          <span className="badge">{campaign.dealers.length}</span>
                        }
                      </td>
                    </PublishStatusTableRow>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <h2>Kommende Kampanjeoverstyringer</h2>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th title="Publiseringsstatus"></th>
                  <th>Navn</th>
                  <th>Plassering</th>
                  <th>Til - fra</th>
                  <th>Kampanjetittel</th>
                </tr>
              </thead>

              <tbody>
                {this.state.overridesUpcoming.map((overrideUpcoming) => {
                  if (!overrideUpcoming.primary) {
                    return;
                  }
                  return (
                    <PublishStatusTableRow entry={overrideUpcoming} key={`overrideUpcoming1-${overrideUpcoming.id}`}>
                      <td className="text-center">
                        <PublishStatusDot entry={overrideUpcoming} />
                      </td>
                      <td>
                        <Link to={`/motorforum/campaigns/override/${overrideUpcoming.id}`}>{overrideUpcoming.name}</Link>
                      </td>
                      <td><strong>Primærkampanje</strong></td>
                      <td>{overrideUpcoming.startDate.toLocaleDateString('nb')} - {overrideUpcoming.expiryDate.toLocaleDateString('nb')}</td>
                      <td><Link to={`/campaigns/${overrideUpcoming.campaign.id}`}>{overrideUpcoming.campaign.name}</Link></td>
                    </PublishStatusTableRow>
                  );
                })}
              </tbody>

              <tbody>
                {this.state.overridesUpcoming.map((overrideUpcoming) => {
                  if (overrideUpcoming.primary) {
                    return;
                  }
                  return (
                    <PublishStatusTableRow entry={overrideUpcoming} key={`overrideUpcoming1-${overrideUpcoming.id}`}>
                      <td className="text-center">
                        <PublishStatusDot entry={overrideUpcoming} />
                      </td>
                      <td>
                        <Link to={`/motorforum/campaigns/override/${overrideUpcoming.id}`}>{overrideUpcoming.name}</Link>
                      </td>
                      <td>{overrideUpcoming.overrideIndex + 1}</td>
                      <td>{overrideUpcoming.startDate.toLocaleDateString('nb')} - {overrideUpcoming.expiryDate.toLocaleDateString('nb')}</td>
                      <td><Link to={`/campaigns/${overrideUpcoming.campaign.id}`}>{overrideUpcoming.campaign.name}</Link></td>
                    </PublishStatusTableRow>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    );
  }
}

CampaignOverridesOverview.defaultProps = {
};

export default withRouter(CampaignOverridesOverview);
